export default "__VITE_ASSET__UzsBqh7L__"